import React, { Component, lazy, Suspense } from 'react';
import { createHashHistory } from 'history';
import { Switch } from "react-router-dom";
import { Route } from "react-router-dom";
import Auth from "../../Layout/Auth";

const ContactManagementPage = lazy(() => import('../Pages/ContactManagementPage'))
class ContactManagementRoute extends Component {
  render() {
    const history = createHashHistory();
    const { allowedRoles } = this.props;
    return (

      <Switch>

        {/*****************ContactManagementRoute****************/}
        <Route
          exact
          path="/:lng/contact_management"
          render={() => (
            <Auth history={history} allowedRoles={['app_admin', 'admin', 'user', 'staff']}>
              <Suspense fallback={<Loading />}>
                <ContactManagementPage history={history} location={location} />
              </Suspense>
            </Auth>
          )}
        />
        {/*****************ContactManagementRoute****************/}

      </Switch>
    );
  }
}
export default ContactManagementRoute;

function Loading() {
  return (
    <>
      <div className="wrapper">
        <span>Loading...</span>
      </div>
    </>
  );
}
